import Carousel from 'react-bootstrap/Carousel';
import styles from './Carousel.module.css';
import { Link } from 'react-router-dom';

// Import the images
import image1 from '../Assets/png.png';
import image2 from '../Assets/chip2.jpg';
import image3 from '../Assets/chip3.jpeg';


function CarouselFadeExample() {
    return (
        <Carousel fade className={styles.carouselContainer}>
            <Carousel.Item>
                <img className={`d-block w-100 ${styles.carouselImage}`} src={image1} alt="First slide" />
                <Carousel.Caption className={styles.captionBox}>
                    <h1 className={styles.heading}>
                        The Future of <span className={styles.highlight}>AI</span> Hardware.
                    </h1>
                    <p className={styles.pheading}>We develop advanced, custom hardware solutions that drive the future of artificial intelligence and smart technologies.</p>
                    <Link className={styles.exploreButton} to="/products">
                        Explore Our Products
                    </Link>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img className={`d-block w-100 ${styles.carouselImage}`} src={image2} alt="Second slide" />
                <Carousel.Caption className={styles.captionBox}>
                    <h3 className={styles.slideTitle}>Edge AI SoCs</h3>
                    <p className={styles.slideSubtitle}>High-performance, low-power solutions for on-device intelligence. Coming soon.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img className={`d-block w-100 ${styles.carouselImage}`} src={image3} alt="Third slide" />
                <Carousel.Caption className={styles.captionBox}>
                    <h3 className={styles.slideTitle}>Analog Mixed Signal IPs</h3>
                    <p className={styles.slideSubtitle}>Phase Locked Loop (PLL) and Analog-to-Digital Converters (ADC). Coming soon.</p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

export default CarouselFadeExample;
